
import React, { useState } from 'react';

function FeedbackModal({ onClose, onSend, loading = false, toEmail = '' }) {
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!toEmail.trim()) {
            alert('Recipient email is missing.');
            return;
        }

        if (!subject.trim() || !message.trim()) {
            alert('Please enter both subject and message.');
            return;
        }

        onSend({
            to: toEmail.trim(),
            subject: subject.trim(),
            message: message.trim()
        });
    };

    return (
        <div
            onClick={onClose}
            style={{
                position: 'fixed',
                inset: 0,
                background: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '1rem',
                zIndex: 1000
            }}
        >
            <div
                role="dialog"
                aria-modal="true"
                aria-labelledby="feedback-modal-title"
                onClick={(e) => e.stopPropagation()}
                style={{
                    background: '#fff',
                    width: '100%',
                    maxWidth: '500px',
                    padding: '1.5rem',
                    borderRadius: '12px',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)'
                }}
            >
                <h2
                    id="feedback-modal-title"
                    style={{ margin: '0 0 1.25rem', color: '#111827' }}
                >
                    Feedback
                </h2>

                <form onSubmit={handleSubmit}>
                    {/* To Email */}
                    <div style={{ marginBottom: '1rem' }}>
                        <label
                            htmlFor="feedback-to"
                            style={{
                                display: 'block',
                                marginBottom: '0.5rem',
                                fontWeight: '600'
                            }}
                        >
                            To
                        </label>

                        <input
                            id="feedback-to"
                            type="email"
                            value={toEmail}
                            readOnly
                            required
                            placeholder="Creator email"
                            style={{
                                width: '100%',
                                boxSizing: 'border-box',
                                padding: '0.75rem',
                                border: '1px solid #d1d5db',
                                borderRadius: '6px',
                                fontSize: '1rem',
                                background: '#f9fafb',
                                color: '#374151'
                            }}
                        />
                    </div>

                    {/* Subject */}
                    <div style={{ marginBottom: '1rem' }}>
                        <label
                            htmlFor="feedback-subject"
                            style={{
                                display: 'block',
                                marginBottom: '0.5rem',
                                fontWeight: '600'
                            }}
                        >
                            Subject *
                        </label>

                        <input
                            id="feedback-subject"
                            type="text"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            placeholder="Enter feedback subject"
                            maxLength={200}
                            required
                            style={{
                                width: '100%',
                                boxSizing: 'border-box',
                                padding: '0.75rem',
                                border: '1px solid #d1d5db',
                                borderRadius: '6px',
                                fontSize: '1rem'
                            }}
                        />
                    </div>

                    {/* Message */}
                    <div style={{ marginBottom: '1.5rem' }}>
                        <label
                            htmlFor="feedback-message"
                            style={{
                                display: 'block',
                                marginBottom: '0.5rem',
                                fontWeight: '600'
                            }}
                        >
                            Message *
                        </label>

                        <textarea
                            id="feedback-message"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            placeholder="Enter your feedback..."
                            rows={5}
                            required
                            style={{
                                width: '100%',
                                boxSizing: 'border-box',
                                padding: '0.75rem',
                                border: '1px solid #d1d5db',
                                borderRadius: '6px',
                                fontSize: '1rem',
                                resize: 'vertical'
                            }}
                        />
                    </div>

                    {/* Buttons */}
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: '0.75rem'
                        }}
                    >
                        <button
                            type="button"
                            onClick={onClose}
                            disabled={loading}
                            style={{
                                padding: '0.7rem 1.25rem',
                                background: '#e5e7eb',
                                color: '#111827',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: loading ? 'not-allowed' : 'pointer'
                            }}
                        >
                            Cancel
                        </button>

                        <button
                            type="submit"
                            disabled={loading || !toEmail.trim()}
                            style={{
                                padding: '0.7rem 1.25rem',
                                background: '#2563eb',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: loading || !toEmail.trim()
                                    ? 'not-allowed'
                                    : 'pointer',
                                opacity: loading || !toEmail.trim() ? 0.7 : 1
                            }}
                        >
                            {loading ? 'Sending...' : 'Send'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default FeedbackModal;
